import {space} from "../provider_api";
import IPriceProto = space.kenko.proto.IPriceProto;
import {Runtime} from "node:inspector";
import PriceProto = space.kenko.proto.PriceProto;
import {Long} from "protobufjs";

export const priceToString = (price: IPriceProto | null | undefined,
                              showCurrencySign?: boolean) => {

  if (price == null || price.amount == null || !price.currencyCode) {
    return 'ERROR';
  }

  return amountToString(price.amount as number, price.currencyCode, showCurrencySign);
}

export const amountToString = (amount: number | Long | null | undefined,
                              currencyCode: string | null | undefined,
                              showCurrencySign?: boolean) => {

  if (amount == null || !currencyCode) {
    return 'ERROR';
  }

  switch (currencyCode.toLowerCase()) {

    case 'usd': {
      const dollars = Math.floor((amount as number) / 100);
      const cents = amount as number % 100;
      return (showCurrencySign ? '$' : '') +
          dollars +
          (cents > 0 ? ('.' + cents.toString().padStart(2, '0')) : '');
    }
  }
}
